import { useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Editable, useFocused } from 'slate-react';

import { useIsTranslated } from 'src/lib/hooks';

import LeafText from '../LeafText';

import useStyles from './useStyles';

const propTypes = {
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  hideMarks: PropTypes.bool,
  classes: PropTypes.shape(),
  onFocusChange: PropTypes.func,
};

const defaultProps = {
  className: null,
  readOnly: false,
  hideMarks: false,
  classes: null,
  onFocusChange: null,
};

const MarkedEditable = ({
  className,
  classes,
  onFocusChange,
  readOnly,
  hideMarks,
  ...restProps
}) => {
  const styles = useStyles({ classes });
  const isTranslated = useIsTranslated();
  const isReadOnly = isTranslated || readOnly;

  const focused = useFocused();
  useEffect(() => {
    if (onFocusChange) {
      onFocusChange(focused);
    }
  }, [onFocusChange, focused]);

  return (
    <Editable
      className={cx(styles.root, className, {
        [styles.readOnly]: isReadOnly,
        [styles.displayMarks]: !hideMarks,
      })}
      renderLeaf={(leafProps) => (
        <LeafText
          {...leafProps}
          readOnly={isReadOnly}
        />
      )}
      data-testid="markedEditable"
      readOnly={isReadOnly}
      {...restProps}
    />
  );
};

MarkedEditable.propTypes = propTypes;
MarkedEditable.defaultProps = defaultProps;

export default MarkedEditable;
